import FormDevis from '../components/FormDevis'

export default function DevisPage() {
  return <FormDevis />
}
